export const LaunchDarklyStatuses = {
  INITIALIZING: 'INITIALIZING',
  ACTIVE: 'ACTIVE',
  FAILED: 'FAILED'
};
